import { Injectable } from "@angular/core";
import { BehaviorSubject, map, Observable } from "rxjs";
import { AzureGroupedRegion } from "../core";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { brdCatchError } from "../shared/message-utils";

@Injectable({
  providedIn: "root"
})
export class RegionService {
  private apiUrl: string = environment.API + "/AzureRegion";
  private regionSubject = new BehaviorSubject<AzureGroupedRegion[]>([]);
  regions$ = this.regionSubject.asObservable();

  constructor(private http: HttpClient) {}

  getRegion(): Observable<AzureGroupedRegion[]> {
    return this.http.get<AzureGroupedRegion[]>(this.apiUrl + "/getGroupedRegion").pipe(
      brdCatchError(),
      map(regions => {
        const enableRegions = regions.filter(r => r.enable);
        this.regionSubject.next(enableRegions);

        return regions;
      })
    );
  }

  getQuotas(regionId: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/${regionId}/quotaExceeded`).pipe(brdCatchError());
  }
}
